import EntityRef from "./company-snapshot/EntityRef";
import FinancialStmt from "./company-snapshot/FinancialStmt";
import Kpis from "./company-snapshot/Kpis";
import Segments from "./company-snapshot/Segments";
import Industry from "./company-snapshot/Industry";
import AllEstimates from "./company-snapshot/AllEstimates";
import CurrentAnalytics from "./company-snapshot/CurrentAnalytics";
import PriceVolumeAnalytics from "./company-snapshot/PriceVolumeAnalytics";
import LHAnalytics from "./company-snapshot/LHAnalytics";

import CorporateActions from "./events/CorporateActions";
import EarningsCorporate from "./events/EarningsCorporate";
import Economic from "./events/Economic";
import Holidays from "./events/Holidays";
import Ipo from "./events/Ipo";
import MergerAcquition from "./events/MergerAcquition";

import EsgScores from "./esg/EsgScores";
import DiversityInclusionScores from "./esg/DiversityInclusionScores";
import EnvironmentalMeasures from "./esg/EnvironmentalMeasures";
import SocialMeasures from "./esg/SocialMeasures";
import GovernanceMeasures from "./esg/GovernanceMeasures";

import Edgar from "./filings/Edgar";
import Cris from "./filings/Cris";
import Sedar from "./filings/Sedar";
import Tanshin from "./filings/Tanshin";
import Yuho from "./filings/Yuho";
import Obi from "./filings/Obi";
import China from "./filings/China";
import Dart from "./filings/Dart";
import Bridge from "./filings/Bridge";
import SecNonEdgar from "./filings/SecNonEdgar";
import Italy from "./filings/Italy";
import Muni from "./filings/Muni";

import Measures from "./estimates/Measures";
import Fields from "./estimates/Fields";

import LipperFunds from "./lipper-funds/LipperFunds";

import Packages from "./news/Packages";

import StreamingQuotes from "./streaming/StreamingQuotes";

import OwnershipPackages from "./ownership/Packages";
import OwnershipFields from "./ownership/Fields";
import OwnershipStocks from "./ownership/Stocks";
import OwnershipFunds from "./ownership/Funds";

import Upload from "./admin/Upload";
import Profile from "./admin/Profile";
import UserManagement from "./admin/UserManagement";

import Auth from '../methods/Auth';

function MainContent({ activeTab }) {
  const componentMap = {
    '0.1': Auth.role === "owner" || Auth.role === "admin" ? <Upload /> : <div><h2>Access Denied</h2><p>You do not have permission to access this page.</p></div>,
    '0.2': Auth.role === "owner" || Auth.role === "admin" || Auth.role === "user" ? <Profile /> : <div><h2>Access Denied</h2><p>You do not have permission to access this page.</p></div>,
    '0.3': Auth.role === "owner" ? <UserManagement /> : <div><h2>Access Denied</h2><p>You do not have permission to access this page.</p></div>,
    '1.1': <EntityRef />,
    '1.2': <FinancialStmt />,
    '1.3': <Kpis />,
    '1.4': <Segments />,
    '1.5': <Industry />,
    '1.6': <CurrentAnalytics />,
    '1.7': <PriceVolumeAnalytics />,
    '1.8': <AllEstimates />,
    '1.9': <LHAnalytics />,
    '2.1': <CorporateActions />,
    '2.2': <EarningsCorporate />,
    '2.3': <Economic />,
    '2.4': <Holidays />,
    '2.5': <Ipo />,
    '2.6': <MergerAcquition />,
    '3.1': <EsgScores />,
    '3.2': <DiversityInclusionScores />,
    '3.3': <EnvironmentalMeasures />,
    '3.4': <SocialMeasures />,
    '3.5': <GovernanceMeasures />,
    '4.1': <Edgar />,
    '4.2': <Cris />,
    '4.3': <Sedar />,
    '4.4': <Tanshin />,
    '4.5': <Yuho />,
    '4.6': <Obi />,
    '4.7': <China />,
    '4.8': <Dart />,
    '4.9': <Bridge />,
    '4.10': <SecNonEdgar />,
    '4.11': <Italy />,
    '4.12': <Muni />,
    '5.1': <Measures />,
    '5.2': <Fields />,
    '6.1': <LipperFunds tabIndex={0} />,
    '6.2': <LipperFunds tabIndex={1} />,
    '6.3': <LipperFunds tabIndex={2} />,
    '6.4': <LipperFunds tabIndex={3} />,
    '6.5': <LipperFunds tabIndex={4} />,
    '7.1': <Packages />,
    '8.1': <OwnershipPackages />,
    '8.2': <OwnershipFields />,
    '8.3': <OwnershipStocks />,
    '8.4': <OwnershipFunds />,
    '9.1': <StreamingQuotes tabIndex={0} />,
    '9.2': <StreamingQuotes tabIndex={1} />,
    '9.3': <StreamingQuotes tabIndex={2} />,
    '9.4': <StreamingQuotes tabIndex={3} />,
    '9.5': <StreamingQuotes tabIndex={4} />,

  };

  return componentMap[activeTab] || null;
}

export default MainContent;
